var _rect, _rect2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChooseIcon03(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 86,
    viewBox: "0 0 86 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 3.24487,
    width: 80,
    height: 80,
    rx: 40,
    fill: "white",
    fillOpacity: 0.07
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 5.24487,
    width: 76,
    height: 76,
    rx: 38,
    stroke: "white",
    strokeOpacity: 0.06,
    strokeWidth: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.4653 30.8518H37.5934V37.5455H30.9993V48.4173H37.5934V55.1118H48.4653V48.4173H55.0586V37.5455H48.4653V30.8518Z",
    stroke: "#34CDFA",
    strokeWidth: 0.955555,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.9877 20.7866C40.8926 20.7866 39.1941 19.0881 39.1941 16.993C39.1941 14.8979 40.8926 13.1995 42.9877 13.1995C45.0828 13.1995 46.7812 14.8979 46.7812 16.993C46.7812 19.0881 45.0828 20.7866 42.9877 20.7866Z",
    stroke: "#34CDFA",
    strokeWidth: 0.955555,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7455 28.2087C22.6504 28.2087 20.952 26.5103 20.952 24.4151C20.952 22.32 22.6504 20.6216 24.7455 20.6216C26.8406 20.6216 28.5391 22.32 28.5391 24.4151C28.5391 26.5103 26.8406 28.2087 24.7455 28.2087Z",
    stroke: "#34CDFA",
    strokeWidth: 0.955555,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M61.2611 28.2087C59.166 28.2087 57.4676 26.5103 57.4676 24.4151C57.4676 22.32 59.166 20.6216 61.2611 20.6216C63.3563 20.6216 65.0547 22.32 65.0547 24.4151C65.0547 26.5103 63.3563 28.2087 61.2611 28.2087Z",
    stroke: "#34CDFA",
    strokeWidth: 0.955555,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M42.9877 72.7441C40.8926 72.7441 39.1941 71.0457 39.1941 68.9505C39.1941 66.8554 40.8926 65.157 42.9877 65.157C45.0828 65.157 46.7812 66.8554 46.7812 68.9505C46.7812 71.0457 45.0828 72.7441 42.9877 72.7441Z",
    stroke: "#34CDFA",
    strokeWidth: 0.955555,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7455 65.3217C22.6504 65.3217 20.952 63.6233 20.952 61.5282C20.952 59.4331 22.6504 57.7346 24.7455 57.7346C26.8406 57.7346 28.5391 59.4331 28.5391 61.5282C28.5391 63.6233 26.8406 65.3217 24.7455 65.3217Z",
    stroke: "#34CDFA",
    strokeWidth: 0.955555,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M61.2611 65.3217C59.166 65.3217 57.4676 63.6233 57.4676 61.5282C57.4676 59.4331 59.166 57.7346 61.2611 57.7346C63.3563 57.7346 65.0547 59.4331 65.0547 61.5282C65.0547 63.6233 63.3563 65.3217 61.2611 65.3217Z",
    stroke: "#34CDFA",
    strokeWidth: 0.955555,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9916 46.2202C14.8965 46.2202 13.198 44.5217 13.198 42.4266C13.198 40.3315 14.8965 38.6331 16.9916 38.6331C19.0867 38.6331 20.7852 40.3315 20.7852 42.4266C20.7852 44.5217 19.0867 46.2202 16.9916 46.2202Z",
    stroke: "#34CDFA",
    strokeWidth: 0.955555,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M69.0072 46.2202C66.9121 46.2202 65.2137 44.5217 65.2137 42.4266C65.2137 40.3315 66.9121 38.6331 69.0072 38.6331C71.1023 38.6331 72.8008 40.3315 72.8008 42.4266C72.8008 44.5217 71.1023 46.2202 69.0072 46.2202Z",
    stroke: "#34CDFA",
    strokeWidth: 0.955555,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M58.3438 21.9992C57.42 21.3231 56.4502 20.7068 55.4405 20.1558",
    stroke: "#34CDFA",
    strokeWidth: 0.955555,
    strokeMiterlimit: 10
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M68.6484 38.6706C67.9405 34.4462 66.2142 30.5675 63.7313 27.2947",
    stroke: "#34CDFA",
    strokeWidth: 0.955555,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M63.7549 58.6719C66.4113 55.1595 68.1966 50.951 68.7891 46.3691",
    stroke: "#34CDFA",
    strokeWidth: 0.955555,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7755 68.7345C51.0691 68.1094 55.0227 66.4356 58.3672 63.9814",
    stroke: "#34CDFA",
    strokeWidth: 0.955555,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7049 67.6548C36.1502 68.1413 37.6528 68.5036 39.1992 68.7306",
    stroke: "#34CDFA",
    strokeWidth: 0.955555,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5681 63.9353C28.5611 64.6687 29.609 65.3328 30.7031 65.9213",
    stroke: "#34CDFA",
    strokeWidth: 0.955555,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M17.161 45.9958C17.7033 50.7235 19.5133 55.0657 22.2422 58.6745",
    stroke: "#34CDFA",
    strokeWidth: 0.955555,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3516 27.1846C19.8305 30.4709 18.077 34.3759 17.3572 38.6321",
    stroke: "#34CDFA",
    strokeWidth: 0.955555,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1406 17.2771C34.9115 17.9062 31.0144 19.5537 27.7074 21.9625",
    stroke: "#34CDFA",
    strokeWidth: 0.955555,
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5391 18.427C50.0357 17.9046 48.4701 17.5168 46.856 17.2771",
    stroke: "#34CDFA",
    strokeWidth: 0.955555,
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M58.3672 27.2947L54.5712 31.0906",
    stroke: "#34CDFA",
    strokeWidth: 0.955555,
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M42.9922 20.7866V26.1927",
    stroke: "#34CDFA",
    strokeWidth: 0.955555,
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7053 27.2947L31.5195 31.1089",
    stroke: "#34CDFA",
    strokeWidth: 0.955555,
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M20.786 42.4268H26.1172",
    stroke: "#34CDFA",
    strokeWidth: 0.955555,
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5691 58.0572L31.4375 54.188",
    stroke: "#34CDFA",
    strokeWidth: 0.955555,
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M42.9922 65.157V59.8123",
    stroke: "#34CDFA",
    strokeWidth: 0.955555,
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M58.3672 58.6718L54.58 54.8838",
    stroke: "#34CDFA",
    strokeWidth: 0.955555,
    strokeMiterlimit: 10
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2148 42.4268H59.8247",
    stroke: "#34CDFA",
    strokeWidth: 0.955555,
    strokeMiterlimit: 10
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M54.1289 27.0032C50.974 24.8046 47.1382 23.5154 43.0023 23.5154C32.2411 23.5154 23.5177 32.2388 23.5177 43C23.5177 47.4417 25.0036 51.5355 27.5055 54.813",
    stroke: "#34CDFA",
    strokeWidth: 0.955555,
    strokeMiterlimit: 10
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5059 57.9521C33.8886 60.7813 38.2451 62.4846 42.9998 62.4846C53.7609 62.4846 62.4844 53.7612 62.4844 43C62.4844 38.5822 61.0144 34.5083 58.5363 31.2395",
    stroke: "#34CDFA",
    strokeWidth: 0.955555,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChooseIcon03);
export default __webpack_public_path__ + "static/media/choose_icon03.795bb582ee3c27ca6c8d7f785a96f29e.svg";
export { ForwardRef as ReactComponent };